import { DomainEvent } from "./DomainEvent";

export class UserFollowEvent extends DomainEvent {
    static eventType = 'user_follow';

    #userId;
    #followedUserId;
    #action;
    #flow;
    #countrySeller;

    constructor(userId, followedUserId, action, flow, countrySeller) {
        super(UserFollowEvent.eventType);
        this.#userId = userId;
        this.#followedUserId = followedUserId;
        this.#action = action;
        this.#flow = flow;
        this.#countrySeller = countrySeller;
    }

    get userId() {
        return this.#userId;
    }

    get followedUserId() {
        return this.#followedUserId;
    }

    get action() {
        return this.#action;
    }

    get flow() {
        return this.#flow;
    }

    get countrySeller() {
        return this.#countrySeller;
    }

}
